import PropTypes from "prop-types";
import "./RenderAvatarSvg.scss";

const RenderAvatarSvg = ({ shape, color1, color2, size = 60 }) => {
  return (
    <svg className="render-avatar-svg" width={size} height={size}>
      {shape === "square" && <rect width={size} height={size} fill={color1} />}
      {shape === "halfTriangle" && (
        <>
          <polygon points={`0,0 ${size},0 0,${size}`} fill={color1} />
          <polygon
            points={`${size},${size} ${size},0 0,${size}`}
            fill={color2}
          />
        </>
      )}
    </svg>
  );
};

RenderAvatarSvg.propTypes = {
  shape: PropTypes.string.isRequired,
  color1: PropTypes.string.isRequired,
  color2: PropTypes.string.isRequired,
  size: PropTypes.number, // size prop to control both width and height - optionnal
};

export default RenderAvatarSvg;

/* Example
  <RenderAvatarSvg shape="square" color1="#D6C79A" color2="#D6C79A" size={80} /> */
